// libs
import React, { memo } from 'react';

// analytics
import { onCartClick } from 'shared/components/Header/analytics';

// helpers
import { getMobileCheckoutURI } from 'shared/helpers/utils/checkout';

// hooks
import { useKeyboardClick } from 'shared/hooks/useKeyboardClick';

// styled components
import { CartButton, CartNumber } from './styles';

// componenets
import CartNudge from 'shared/layouts/DetailsPage/components/CartNudge';

// icons
import { useStoreIcon, IconName } from 'shared/icons';

//context
import { useDomainConfig } from 'shared/domainConfig/context/context';

// constants
import { CART_INTERACTION_LOCATION } from 'shared/helpers/analytics/constants/cart';
const BAG_ICON = 'BagIcon';

// defs
interface ICartProps {
  cartCount: number | string;
  showToast: boolean;
  toastMessage: string;
}

function Cart({ cartCount, showToast, toastMessage }: ICartProps) {
  // Get store-aware cart icon
  const CartIcon = useStoreIcon(IconName.CART);

  const {
    COLOR: {
      CART_COUNT: { TEXT, BACKGROUND, BORDER },
    },
  } = useDomainConfig();

  const goToCart = (isToastClicked: boolean) => {
    const location = isToastClicked ? CART_INTERACTION_LOCATION.VIEW_BAG : undefined;

    onCartClick(BAG_ICON, location);
    window.location.href = getMobileCheckoutURI();
  };

  const keyboardProps = useKeyboardClick(() => goToCart(false));
  const cartLabel = cartCount > 0 ? `Shopping cart with ${cartCount} items` : 'Shopping cart';

  return (
    <>
      <CartButton
        {...keyboardProps}
        className="cart"
        aria-label={cartLabel}
        data-at="cart-button"
        data-test="cart-count-button"
      >
        <CartIcon aria-hidden="true" />
        {cartCount > 0 && (
          <CartNumber color={TEXT} bg={BACKGROUND} border={BORDER} aria-hidden="true">
            {cartCount}
          </CartNumber>
        )}
      </CartButton>
      {showToast && (
        <CartNudge onClick={() => goToCart(true)} actionText={'View Bag'} content={toastMessage} />
      )}
    </>
  );
}

export default memo(Cart);
